export const environment = {
  production: false,
  BASE_URL:
  // @ts-ignore
    window['env']['BASE_URL'] || 'http://dev-essb-api.hmm.lan',
  SPLASH_APP_URL:
  // @ts-ignore
    window['env']['SPLASH_APP_URL'] || 'http://k8s-m11.hmm.lan:30823/',
};
